import { render, staticRenderFns } from "./StackedBar.vue?vue&type=template&id=99537bf4&scoped=true"
import script from "./StackedBar.vue?vue&type=script&lang=js"
export * from "./StackedBar.vue?vue&type=script&lang=js"
import style0 from "./StackedBar.vue?vue&type=style&index=0&id=99537bf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99537bf4",
  null
  
)

export default component.exports